import React from 'react';
import { Alert, Box, Card, CardContent, LinearProgress, Skeleton, Typography } from '@mui/material';
import { ShowChart } from '@mui/icons-material';
import AccountTrendChart from '../AccountTrendChart';
import { useAccountDashboard } from './AccountDashboardContext';

export default function AccountDashboardSection() {
  const {
    accessGranted,
    trendData,
    trendLoading,
    trendRefreshing,
    trendError,
    metric,
    granularity,
    focus,
    setFocusFromBucket
  } = useAccountDashboard();

  if (accessGranted === null) {
    return null;
  }

  if (!accessGranted) {
    return null;
  }

  return (
    <>
      {trendError && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {trendError}
        </Alert>
      )}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
            <ShowChart color="primary" />
            <Typography variant="h6">Account trend</Typography>
            {trendData?.window.label && granularity !== 'all' && (
              <Typography variant="body2" color="text.secondary">
                {trendData.window.label}
              </Typography>
            )}
          </Box>
          {trendLoading && !trendData ? (
            <Skeleton variant="rounded" height={300} />
          ) : (
            <Box sx={{ position: 'relative', width: '100%', minWidth: 0, minHeight: 300 }}>
              {trendRefreshing && (
                <LinearProgress
                  sx={{ position: 'absolute', top: 0, left: 0, right: 0, zIndex: 1 }}
                />
              )}
              <AccountTrendChart
                data={trendData}
                metric={metric}
                granularity={granularity}
                focusKey={focus?.key ?? null}
                onFocusBucketClick={granularity === 'all' ? undefined : setFocusFromBucket}
              />
            </Box>
          )}
        </CardContent>
      </Card>
    </>
  );
}
